// extracted by mini-css-extract-plugin
module.exports = {"desktopVideo":"interview-video-module--desktopVideo--1qSHl","mobileVideo":"interview-video-module--mobileVideo--jGiUe"};